<script setup>
import { Visibility, VISIBILITY_TO_READABLE } from '@pfsc/core/models/visibility';
import { lookupService } from '@pfsc/core/services/lookup.service';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import { onMounted, ref } from 'vue';

defineProps({
  modelValue: {
    type: [Visibility, Object],
    required: false,
  },
});

const emits = defineEmits(['update:model-value']);

const items = ref([]);

onMounted(async () => {
  items.value = await lookupService.getVisibilities();
});

const TO_READABLE = {
  ...VISIBILITY_TO_READABLE,
  All: globalTranslate('userStatus.all'),
};

/**
 * To readable visibility.
 * @param {object} visibility Visibility.
 * @returns {string}
 */
function toReadableVisibility(visibility) {
  return TO_READABLE[visibility.name];
}

</script>
<template>
  <v-select
    :model-value="modelValue"
    :items="items"
    :item-title="toReadableVisibility"
    return-object
    hide-details
    @update:model-value="emits('update:model-value', $event)"
  />
</template>
